export const base = "https://api.cannalogic.co/commoncova/user/royalleafs" // NEW BASE URL
// export const base = "https://api.cannalogic.co/commoncova/user/royalleafs/userpromo" // Promo BASE URL

// export const base = "https://dcf9-2405-201-4003-70e6-dac9-f-469b-c26a.ngrok-free.app/commoncova/user/royalleafs/" // NEW BASE URL


export let base1 = "https://api.uttarakhandherbs.com/common/cova/" // For Live purposes only
